import servicioBase from '@/services/servicio-base';

const servicioFacturas = {};
//const url = config.apiUrl

servicioFacturas.consultarFacturas = function(fechaInicio, fechaFin, tipoDocumento) {
   return servicioBase.post('/facturas/consultar', {fechaInicio, fechaFin, tipoDocumento})
  .then(r => {
     return r.data;
  })
  .catch(e => {
     return e;
  })
}

servicioFacturas.descargarFacturas = function(facturas) {
   return servicioBase.post('/facturas/descargar', facturas)
  .then(r => {
     return r.data;
  })
  .catch(e => {
     return e;
  })
}

servicioFacturas.correosFrecuentesCon = function() {
    return servicioBase.get('/facturas/correosCon')
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicioFacturas.correosFrecuentesActualizar = function(correos) {
   console.log(correos)
    return servicioBase.post('/facturas/correosActualizar', correos)
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicioFacturas.enviarPorCorreo = function(facturas, correos) {
   return servicioBase.post('/facturas/enviarPorCorreo', {facturas, correos})
  .then(r => {
     return r.data;
  })
  .catch(e => {
     return e;
  })
}

export default servicioFacturas;